// The hosts of the image viewer and the video viewer. Mount once per document
// screen, next to the editor or the static body (not inside the
// contenteditable): images and videos only dispatch an open signal, and these
// hosts draw the layer. Works the same for the live editor and a static body,
// since the signal bubbles from the pressed element to window either way.
import { FileLightbox } from "./file-lightbox";
import { VideoViewer } from "./video-viewer";

export function MediaLayers() {
  return (
    <>
      <FileLightbox />
      <VideoViewer />
    </>
  );
}
